import React from "react";
import { useSelector } from "react-redux";
import { actionCreators } from "./redux/membershipUnitsSagas";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import LearnMore from "../../../components/learnMore/learnMore";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import TotalMembers from "./smartComponents/TotalMembers";
import NetUnits from "./smartComponents/NetUnits";
import YearOverYear from "./smartComponents/YearOverYear";
import FrozenMembers from "./smartComponents/FrozenMembers";
import ChurnRatePercent from "./smartComponents/ChurnRatePercent";
import ScheduledCancellations from "./smartComponents/ScheduledCancellations";
import TotalNewMembers from "./smartComponents/TotalNewMembers";
import CancelledMembers from "./smartComponents/CancelledMembers";
import NewMembers from "./smartComponents/NewMembers";
import ReactivatedMembers from "./smartComponents/ReactivatedMembers";
import { PreviousToggle } from "./smartComponents/PreviousToggle";
import TotalPastDues from "./smartComponents/TotalPastDues";
import { useFetchData } from "../hooks/dataFetchingHooks";

const MembershipUnitsModule = (props) => {
  useFetchData({
    moduleName: "membershipUnits",
    props,
    fetchData: actionCreators.fetchCurrentUser,
    updateData: actionCreators.updateAllData
  });
  const { qa } = useSelector((state) => state.commonReducer.commonProps);
  const isLoading = useSelector((state) => state.membershipUnits.isLoading);
  const displayTotalNewMembers = useSelector(
    (state) => state.membershipUnits.membershipUnits.totalNewMembers.displayTotalNewMembers
  );

  return (
    <SectionToggle
      title="Membership Units"
      learnMore={<LearnMore {...props.learnMore} html />}
      customClass={`membershipunitsWidget ${isLoading ? "" : "active"}`}
      height={780}
      isLoading={isLoading}
      content={
        <>
          <PreviousToggle />
          <div className="content">
            <TotalMembers qa={qa} />
            <FrozenMembers qa={qa} />
            {displayTotalNewMembers ? (
              <>
                <TotalNewMembers qa={qa} />
                <CancelledMembers qa={qa} />
                <NewMembers qa={qa} />
                <ReactivatedMembers qa={qa} />
              </>
            ) : null}

            <NetUnits qa={qa} />
            <div className="content__el">
              <ChurnRatePercent qa={qa} />
            </div>
            <div className="content__el">
              <ScheduledCancellations qa={qa} />
            </div>
            <TotalPastDues qa={qa} />
            <SectionContainer title="Net Units Day Over Day">
              <YearOverYear />
            </SectionContainer>
          </div>
        </>
      }
    />
  );
};

export default MembershipUnitsModule;
